// extracted by mini-css-extract-plugin
export default {"section":"style_section__o7Du+","section_modal":"style_section_modal__uYcCA","section_modal-title":"style_section_modal-title__dy-+u"};